export default __webpack_public_path__ + "static/4-7a581499648b7c8dc6686117ae20b9b7.jpg";